function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.973 9.86a.294.294 0 00-.267-.193h-3.485l3.44-6.155a.372.372 0 00.008-.34.29.29 0 00-.257-.172h-4.706a.293.293 0 00-.263.184l-4.412 10a.372.372 0 00.013.324.289.289 0 00.25.159h3.025l-3.296 8.87a.358.358 0 00.118.414c.047.033.1.049.153.049a.282.282 0 00.225-.118l9.412-12.667a.37.37 0 00.041-.356z",
  fill: "#000"
});

function SvgBolt(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgBolt;